import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=599a7544&scoped=true"
import script from "./PriceSummary.vue?vue&type=script&lang=js"
export * from "./PriceSummary.vue?vue&type=script&lang=js"
import style0 from "./PriceSummary.vue?vue&type=style&index=0&id=599a7544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599a7544",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductDetailsMinimumPrice: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Product/Details/MinimumPrice.vue').default})
